import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
import { openCustomerStream } from "./stream";

export function usePaymentStatus(paymentId: string | null) {
  const qc = useQueryClient();
  const query = useQuery({
    queryKey: ["payment", paymentId],
    queryFn: () => api.paymentStatus(paymentId!),
    enabled: !!paymentId,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (!paymentId) return;
    const stream = openCustomerStream(
      (event) => {
        if (event.kind === "payment" && event.payment?.paymentId === paymentId) {
          qc.setQueryData(["payment", paymentId], event.payment);
        }
      },
      {
        onStatus: (status) => {
          if (status === "open") void qc.invalidateQueries({ queryKey: ["payment", paymentId] });
        },
      },
    );
    return () => stream.close();
  }, [paymentId, qc]);

  return query;
}
